import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from '@gaiads/telia-react-component-library';

import { bundlePriceTypesInUse } from '../../../utils/prices';

interface PriceTypeDropdownProps {
  priceType?: string;
  onPriceTypeChange: (priceType: string) => void;
}

export function PriceTypeDropdown(props: PriceTypeDropdownProps) {
  const { priceType, onPriceTypeChange } = props;

  const { t } = useTranslation('productsscreen');
  return (
    <>
      {priceType && (
        <Dropdown
          data-testid={`priceType-dropdown`}
          name="priceType"
          className="daas-product-table__price-type"
          showCustomLabel
          options={bundlePriceTypesInUse.map(priceType => ({
            value: priceType[1],
            label: t(`priceTypes.${priceType[1]}`),
          }))}
          selectedOption={{
            value: priceType,
            label: t(`priceTypes.${priceType}`),
          }}
          onChange={(event, option) => onPriceTypeChange(option.value)}
        />
      )}
    </>
  );
}
